import axios from 'axios';
import React from 'react';
import { Select } from 'react-materialize';
import AgeGroup from '../../components/AgeGroup/AgeGroup';
import HeaderPage from '../../components/PageHeader/PageHeader';
import { retornarCookie } from '../../services/cookieservice';
import './DistribuicaoFaixasElegibilidadePage.css';
import Loader from '../../components/Loader/Loader';

const { REACT_APP_API,REACT_APP_AGE_LIMIT } = process.env;

export default class DistribuicaoFaixasElegibilidadePage extends React.Component {
  constructor(props) {
    super(props);

    this.somar = this.somar.bind(this);
    this.subtrair = this.subtrair.bind(this);
  }

  state = {
    totalVidas: 0,
    faixas: [],
    faixasComplementares: [],
    vidasrestantes: undefined,
    exibeCarregamento: false,
  };

  componentWillUnmount() {
    localStorage.removeItem('VidasDistribuicao');
  }

  componentDidMount() {
    this.carregarVidasRestantes();
    this.carregarFaixaEtaria(true);
    this.carregarFaixaEtaria(false);
  }

  async carregarFaixaEtaria(limitado) {
    this.setState({ exibeCarregamento: true })
    const params = {
      limitado,
    };

    axios.get(`${REACT_APP_API}dominio/faixaEtaria`, { params }).then((res) => {
      let faixas = [...res.data];

      if (limitado) {
        this.setState({ faixas });
        this.setState({ exibeCarregamento: false })
      } else { 
        faixas = faixas.filter((faixa) => faixa.i9_faixade < REACT_APP_AGE_LIMIT);
        this.setState({ faixasComplementares: faixas }); 
      }
    });
  }

  permitirContinuar = () => {
    const desabilitar = !this.state.faixas.filter((x) => x.total_vidas > 0).length > 0;
    return desabilitar;
  };

  somar = (id) => {
    const totalVidas = this.state.totalVidas + 1;
    const faixas = [
      ...this.state.faixas.map((faixa) => {
        if (faixa.i9_faixaetariapadraoId === id) faixa.total_vidas = faixa.total_vidas + 1;
        return { ...faixa };
      }),
    ];

    this.setState({ totalVidas, faixas });
  };

  subtrair = (id) => {
    const totalVidas = this.state.totalVidas - 1;
    const faixas = [
      ...this.state.faixas.map((faixa) => {
        if (faixa.i9_faixaetariapadraoId === id) faixa.total_vidas = faixa.total_vidas - 1;
        return { ...faixa };
      }),
    ];

    this.setState({ totalVidas, faixas });
  };


  async carregarVidasRestantes() {
    const IdAgenteVendas = retornarCookie('IdAgenteVenda');

    const params = {
      oportunidadeID: this.props.oportunidade.OportunidadeID,
      IdAgenteVendas,
    };

    axios.get(`${REACT_APP_API}elegibilidade/VidasRestantes`, { params }).then((res) => {

      const vidasrestantes = res.data;

      this.setState({ vidasrestantes });
    });
  }

  onChangeFaixasComplementares = (e) => {
    const id = e.target.value;
    const faixas = [...this.state.faixas];

    if (faixas.find((x) => x.i9_faixaetariapadraoId === id)) return;

    const faixaComplementar = this.state.faixasComplementares.find((x) => x.i9_faixaetariapadraoId === id);
    faixas.push(faixaComplementar);

    this.setState({ faixas });
  };

  render() {
    const { oportunidade } = { ...this.props };
    const { totalVidas, faixas, faixasComplementares } = { ...this.state };

    return (
      <div>
        {this.state.exibeCarregamento && <Loader />}

        <div className="row container">
          <HeaderPage />
          <div className="col s5 m5 l5 offset-s3 offset-m3 offset-l3">

            <span className='TotalDistribuicaoElegibilidade'>{this.state.totalVidas} / {localStorage.getItem('VidasDistribuicao')}</span><br />

            {faixas.length > 0 &&
              faixas.map((faixa) => (
                <div className="col s12 m12 l12 ">
                  <AgeGroup
                    id={faixa.i9_faixaetariapadraoId}
                    description={faixa.i9_name}
                    count={totalVidas}
                    max={localStorage.getItem('VidasDistribuicao')}
                    decrement={this.subtrair}
                    increment={this.somar}
                  />
                </div>
              ))}
            <div className="col s12 m12 l12 ">
              <div className="row">
                <div className="col s7 m7 l7 right-align">
                  <b>59-ou mais Anos</b>
                </div>
                <div className="row">
                  <div className="col s4 m4 l4">
                    {faixasComplementares.length > 0 && (
                      <div className="faixasComplementares">
                        <Select
                          id="faixasComplementares"
                          name="faixasComplementares"
                          onChange={(e) => this.onChangeFaixasComplementares(e)}
                        >
                          <option value="">Selecione</option>
                          {faixasComplementares.map((faixa) => (
                            <option value={faixa.i9_faixaetariapadraoId}>{faixa.i9_name}</option>
                          ))}
                        </Select>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col s6 m6 l6 right-align">
              <br />
              <button
                type="button"
                onClick={() => this.props.controlaVisualizacao('SelecaoPlanoElegibilidadePage')}
                className="OmintButton"
              >
                Voltar
              </button>
            </div>

            <div className="col s6 m6 l6 left-align">
              <br />
              <button
                type="button"
                disabled={this.permitirContinuar()}
                onClick={() => this.props.finalizarDistribuicaoFaixasElegibilidade(this.state)}
                className="OmintButton"
              >
                Continuar
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
